export const getTitle = (t, count) => {
  if (!count) return t('cms:cms.students.detail.panel.leads.title');
  return `${t('cms:cms.students.detail.panel.leads.total')} ${count} ${t(
    'cms:cms.students.detail.panel.leads.title',
  )}`;
};
